import { Plugin } from 'prosemirror-state';

import { AddMenuBookmark, FileOutline } from '@lyearn/icons';
import { EditorOptions } from '@lyearn/lygo-core';

import { addMenuItemType } from '../../../types/menus';
import { addAddMenuBlock } from '../../../utils/menus';
import { NODE_NAME } from '../consts';
import WebbookmarkNodeView from './NodeView';

function plugins({ createReactNodeView, t }: EditorOptions) {
  return [
    new Plugin({
      props: {
        nodeViews: {
          webbookmark(node, view, getPos, decorations) {
            return createReactNodeView({
              node,
              view,
              getPos,
              decorations,
              component: WebbookmarkNodeView,
            });
          },
        },
      },
    }),

    new Plugin({
      view: (editorView) => {
        addAddMenuBlock(editorView, [
          {
            name: NODE_NAME,
            title: t('Lygo:Menu.webbookmark.title') as string,
            description: t('Lygo:Menu.webbookmark.description') as string,
            icon: FileOutline,
            addMenuIcon: AddMenuBookmark,
            addMenuItemType: addMenuItemType.media,
            attrs: { href: null },
            searchWords: ['web bookmark', 'media', 'upload'],
          },
        ]);
        return {};
      },
    }),
  ];
}

export default plugins;
